import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import { Box, Checkbox, IconButton, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";

import type { ChildMeta } from "./useReviewSelection";

interface ReviewListToolbarProps {
  allItemsMeta: ChildMeta[];
  checkedCount: number;
  onTopToggle: (
    items: ChildMeta[],
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  onCopy: (format: "markdown" | "plaintext" | "word") => () => Promise<void>;
  onDeleteSelected: () => void;
}

const ReviewListToolbar: React.FC<ReviewListToolbarProps> = ({
  allItemsMeta,
  checkedCount,
  onTopToggle,
  onCopy,
  onDeleteSelected,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const hasSelection = checkedCount > 0;

  return (
    <Box data-testid="review-list-toolbar" px={2} flexDirection="column">
      <Checkbox
        edge="start"
        tabIndex={-1}
        disableRipple
        slotProps={{ input: { "aria-label": "select all" } }}
        onChange={onTopToggle(allItemsMeta)}
      />
      <IconButton
        aria-label="copy-selection"
        size="small"
        disabled={!hasSelection}
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
      <IconButton
        aria-label="delete-selected"
        size="small"
        disabled={!hasSelection}
        onClick={onDeleteSelected}
      >
        <DeleteSweepIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={onCopy("word")} disabled={!hasSelection}>
          Copy selected as Word
        </MenuItem>
        <MenuItem onClick={onCopy("markdown")} disabled={!hasSelection}>
          Copy selected as Markdown
        </MenuItem>
        <MenuItem onClick={onCopy("plaintext")} disabled={!hasSelection}>
          Copy selected as Plain Text
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ReviewListToolbar;
